export default __webpack_public_path__ + "fonts/5bc05e1d241681fe1db66bcaa94e8ea4.ttf";